import { CreditGrantEditorDrawer } from 'modules/Cube/view/common/drawers/creditGrantEditor/drawer/CreditGrantEditorDrawer'
import { useCreditGrantEditorConnector } from 'modules/Cube/view/common/drawers/creditGrantEditor/useCreditGrantEditor.connector'

export const CreditGrantEditorCubeRoute = () => {
  const connector = useCreditGrantEditorConnector()

  if (!connector) {
    return null
  }

  return <CreditGrantEditorDrawer {...connector} />
}
